module.exports = __webpack_public_path__ + "img/button1.308eaa9e.png";